import { Camera, FilmSlate, CalendarBlank, ChatsCircle } from "@phosphor-icons/react";
import { Reveal, ChapterLabel } from "./Reveal";
import { site } from "../content";

const icons = [Camera, FilmSlate, CalendarBlank, ChatsCircle];

export const Services = () => {
  const { services } = site;
  return (
    <section id="palvelut" className="bg-[#EFE6DC] py-24 md:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <ChapterLabel chapter={services.chapter} label={services.label} />
          <h2 className="mt-5 font-serif font-light text-3xl md:text-5xl tracking-tight text-[#2B2724] max-w-2xl">
            {services.title}
          </h2>
        </Reveal>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.items.map((s, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={s.slug} delay={i * 0.08}>
                <article
                  className="group h-full bg-[#FBF8F4] rounded-3xl p-8 shadow-[0_8px_30px_rgba(43,39,36,0.04)] hover:shadow-[0_20px_50px_rgba(43,39,36,0.09)] hover:-translate-y-1.5 transition-[box-shadow,transform] duration-300"
                  data-testid={`service-card-${s.slug}`}
                >
                  <span className="w-12 h-12 rounded-full bg-[#EFE6DC] flex items-center justify-center group-hover:bg-[#7C8C7E] transition-colors duration-300">
                    <Icon
                      size={22}
                      weight="light"
                      className="text-[#4A6572] group-hover:text-[#FBF8F4] transition-colors duration-300"
                    />
                  </span>
                  <h3 className="mt-7 font-serif text-2xl text-[#2B2724]">{s.title}</h3>
                  <p className="mt-3 text-sm md:text-base leading-relaxed text-[#5C564F]">{s.text}</p>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15}>
          <p
            className="mt-16 md:mt-20 text-center font-serif italic text-xl md:text-2xl text-[#2B2724]/75 max-w-3xl mx-auto leading-relaxed"
            data-testid="services-tailor-note"
          >
            {services.tailorNote}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
